import React from 'react';
// Redux
import { useDispatch } from 'react-redux';
import { UserFilters } from '../../../redux/types/filtersTypes';
import { setFilters, resetFilters } from '../../../redux/actions/FiltersActions';
// App
import DashboardComponent from '../../../components/DashboardComponent';
import UserListComponent from '../../../components/Users/UsersListComponent';
// Other
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

export default function UsersRouting(props: RouteComponentProps) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setFilters(new UserFilters()));
    return () => {
      dispatch(resetFilters());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardComponent
      title={<h2>Equipo</h2>}
      children={<Switch>
        <Route exact path={props.match.path + '/list'} component={UserListComponent} />
        <Redirect to={props.match.path + '/list'} />
      </Switch>}
    />
  );
}